import gql from 'graphql-tag';

const UPDATE_LINE_ITEM_MARKED_FOR_DELIVERY = gql`
  mutation updateLineItemMarkedForDelivery($lineItemId: ID!, $data: LineItemUpdateInput!) {
    updateLineItem(where: { id: $lineItemId }, data: $data) {
      id
      markedForDelivery
    }
  }
`;

export default UPDATE_LINE_ITEM_MARKED_FOR_DELIVERY;
